module.exports = __webpack_public_path__ + "static/media/greenhouse2Step8-1.17f08668.jpg";